import React, { Component } from 'react';
import { selectAddress, selectResources, selectIsAddressValid } from '../store/selectors';
import { setAddress, setIsAddressValid } from '../store/actions';
import { connect } from 'react-redux';

class AddressField extends Component {
    addressField = React.createRef();

    setAddress = async (event) => {
        let isValid = true;
        if (this.addressField.current.isValid) {
            isValid = await this.addressField.current.isValid();
        }
        if (event.detail.event === 'validated') {
            this.props.setAddress(event.detail.value);
            this.props.setIsAddressValid(isValid);
        }
    };

    componentDidMount() {
        this.addressField.current.addEventListener('fieldEvent', this.setAddress);
    }

    componentWillUnmount() {
        this.addressField.current.removeEventListener('fieldEvent', this.setAddress);
    }

    render() {
        const { address } = this.props.resources.section2;
        return (
            <flos-address-field
                value={this.props.address}
                id="address"
                label={address.label}
                ref={this.addressField}
                is-required={true}
            />
        );
    }
}

const mapStates = (state) => ({
    resources: selectResources(state),
    address: selectAddress(state),
    isAddressValid: selectIsAddressValid(state)
});

const mapDispatch = (dispatch) => ({
    setAddress: (address) => dispatch(setAddress(address)),
    setIsAddressValid: (isAddressValid) => dispatch(setIsAddressValid(isAddressValid))
});

export default connect(mapStates, mapDispatch)(AddressField);
